const PERF_PREFIX = "[DSN_PERF]";
const PERF_EVENT_NAME = "datasnare:perf-debug-event";

function emitPerfEvent(name, payload) {
    if (typeof window === "undefined") return;

    try {
        window.dispatchEvent(new CustomEvent(PERF_EVENT_NAME, {
            detail: {
                name,
                payload,
                ts: Date.now(),
            },
        }));
    } catch {
        // noop
    }
}

export function getPerfDebugEventName() {
    return PERF_EVENT_NAME;
}

export function isPerfDebugEnabled() {
    if (typeof window === "undefined") return false;

    try {
        const queryEnabled = new URLSearchParams(window.location.search || "").get("perfDebug");
        if (queryEnabled === "1" || String(queryEnabled).toLowerCase() === "true") {
            return true;
        }

        const raw = window.localStorage.getItem("datasnare:perf-debug");
        return raw === "1" || String(raw || "").toLowerCase() === "true";
    } catch {
        return false;
    }
}

export function perfMarkStart(name, context = {}) {
    if (!isPerfDebugEnabled()) {
        return null;
    }

    return {
        name,
        start: (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now(),
        context,
    };
}

export function perfMarkEnd(token, extra = {}) {
    if (!token) return;

    const end = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
    const durationMs = Number((end - token.start).toFixed(2));
    const payload = {
        ...token.context,
        ...extra,
        durationMs,
    };

    // eslint-disable-next-line no-console
    console.info(`${PERF_PREFIX} ${token.name}`, payload);
    emitPerfEvent(token.name, payload);
}

export function perfLog(name, payload = {}) {
    if (!isPerfDebugEnabled()) return;

    // eslint-disable-next-line no-console
    console.info(`${PERF_PREFIX} ${name}`, payload);
    emitPerfEvent(name, payload);
}
